import React from 'react';
import { Color } from '../../const/Const';
import { ReactComponent as FolderIcon } from '../../svg/folderIcon.svg';

const ReportFolder = (props) => {
    return (
        <div style={{ height: 160, width: 160, backgroundColor: Color.white, cursor: 'pointer', marginLeft: 16 }} onClick={() => props.onClick(props.data)}>
            <div style={{ height: 90, width: 160, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: Color.white }}>
                <FolderIcon />
            </div>
            <div style={{ height: 70, width: 160, display: 'flex', justifyContent: 'center', backgroundColor: Color.white }}>
                <div style={{ textAlign: 'center', fontSize: 12, paddingLeft: 8, paddingRight: 8 }}>
                    {props.data?.name?.length > 40 ? (
                        props.data?.name?.substring(0, 40) + "..."
                    ) : (
                        props.data?.name
                    )}
                </div>
            </div>
        </div>
    );
}

export default ReportFolder;